import { Mail, Phone, MapPin, Instagram } from "lucide-react";
import Reveal from "./Reveal";

const MAPS_URL = "https://maps.app.goo.gl/K2VHCDcggPj3ygmh7";
const INSTA_URL = "https://www.instagram.com/hotelkohinoordiu/";
const EMAIL = "info@hotelkohinoordiu.in";
const PHONE = "+91 720 1000 336";

export const ContactCard = () => {
  return (
    <section
      id="verified-contact"
      data-testid="verified-contact-section"
      className="scroll-mt-28 py-16 lg:py-24 bg-[#fdfbf6]"
    >
      <div className="mx-auto max-w-2xl px-6">
        <Reveal>
          <div className="mb-8 text-center sm:text-left">
            <h2 className="font-display text-4xl sm:text-5xl text-[#0a0a0a]">
              Verified <span className="text-[#12729c]">Contact</span>
            </h2>
            <div className="mx-auto sm:mx-0 mt-4 flex items-center justify-center sm:justify-start gap-2">
              <span className="h-1.5 w-12 rounded-full bg-[#29abe2]" />
              <span className="h-1.5 w-6 rounded-full bg-[#f5b301]" />
              <span className="h-1.5 w-3 rounded-full bg-[#c1272d]" />
            </div>
            <p className="mt-4 text-base text-[#52525b]">
              The only official channels for Hotel Kohinoor.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div
            data-testid="verified-contact-card"
            className="rounded-3xl bg-white border border-[#e4e4e7] border-t-[6px] border-t-[#29abe2] shadow-[0_18px_50px_-18px_rgba(41,171,226,0.35)] p-6 sm:p-8"
          >
            {/* Tiles */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <a
                href={`mailto:${EMAIL}`}
                data-testid="contact-email-tile"
                className="group flex items-start gap-3 rounded-2xl border border-[#e4e4e7] p-5 transition-all duration-300 hover:border-[#29abe2]/40 hover:bg-[#29abe2]/[0.05]"
              >
                <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#29abe2]/12 text-[#1683b3] group-hover:bg-[#29abe2] group-hover:text-white transition-colors">
                  <Mail size={19} />
                </span>
                <span className="min-w-0">
                  <span className="block text-xs uppercase tracking-widest text-[#52525b]">Email</span>
                  <span className="block text-[13px] sm:text-[13.5px] font-semibold text-[#0a0a0a] whitespace-nowrap">{EMAIL}</span>
                </span>
              </a>

              <a
                href={`tel:${PHONE.replace(/\s/g, "")}`}
                data-testid="contact-phone-tile"
                className="group flex items-start gap-4 rounded-2xl border border-[#e4e4e7] p-5 transition-all duration-300 hover:border-[#3f9e4d]/40 hover:bg-[#3f9e4d]/[0.05]"
              >
                <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#3f9e4d]/12 text-[#2f7d3a] group-hover:bg-[#3f9e4d] group-hover:text-white transition-colors">
                  <Phone size={19} />
                </span>
                <span className="min-w-0">
                  <span className="block text-xs uppercase tracking-widest text-[#52525b]">Phone</span>
                  <span className="block text-[15px] font-semibold text-[#0a0a0a]">{PHONE}</span>
                </span>
              </a>
            </div>

            {/* Get Directions — full width cyan button */}
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get directions to Hotel Kohinoor on Google Maps (opens in a new tab)"
              data-testid="contact-directions-btn"
              className="mt-4 flex w-full items-center justify-center gap-2 rounded-2xl bg-[#12729c] px-6 py-4 font-display text-sm tracking-widest uppercase text-white transition-all duration-300 hover:bg-[#0f6288] hover:shadow-[0_12px_34px_-6px_rgba(41,171,226,0.6)]"
            >
              <MapPin size={18} />
              Get Directions
            </a>

            {/* Instagram — small link at bottom */}
            <div className="mt-6 flex items-center justify-center">
              <a
                href={INSTA_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Hotel Kohinoor on Instagram (opens in a new tab)"
                data-testid="contact-instagram-link"
                className="inline-flex items-center gap-2 text-sm text-[#52525b] transition-colors hover:text-[#c1272d]"
              >
                <Instagram size={16} />
                @hotelkohinoordiu
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ContactCard;
